import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { Globals } from '../../providers/globals';
import { BusinessDashboardProvider } from '../../providers/business-dashboard';

@Component({
  selector: 'page-business-dashboard',
  templateUrl: 'business-dashboard.html',
})
export class BusinessDashboardPage {
	isRefreshing: boolean = false;

	isLoadingCustomerNumbers: boolean = false;
	isLoadingTopCards: boolean = false;
	isLoadingTopCustomers: boolean = false;

	constructor(
		public globals: Globals,
		public businessDashboardProvider: BusinessDashboardProvider, 
		public navCtrl: NavController, 
		public navParams: NavParams) {
	}

	ionViewDidLoad() {
		this.loadCustmerData(null);
	}

	loadCustmerData(cb){
		this.isLoadingCustomerNumbers = true;
		this.isLoadingTopCards = true;
		this.isLoadingTopCustomers = true;

		this.businessDashboardProvider.getConsumerData({
			cb: ()=>{
				this.isLoadingCustomerNumbers = false;

				this.getTopCards(cb);
			}
		})
	}

	getTopCards(cb){
		this.businessDashboardProvider.getTopCards({
			cb: ()=>{
				this.isLoadingTopCards = false;

				this.getTopCustomers(cb);
			}
		})
	}

	getTopCustomers(cb){
		this.businessDashboardProvider.getTopCustomers({
			cb: ()=>{
				this.isLoadingTopCustomers = false;

				if(typeof cb == "function") cb();
			}
		})
	}	

	doRefresh(refresher){
		this.isRefreshing = true;

		this.loadCustmerData(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/business-dashboard/business-dashboard.ts